import React from "react";
import { Link } from "react-router-dom";
import destinations from '../data/destinations.json';

function TopDestination(){

    // Sort the destinations array by the "to" property in ascending order
    const sortedDestinations = [...destinations].sort((a, b) => 
        a.to.localeCompare(b.to)
    );

    return(
        <>
        <section className="breadcrumb-main pb-15 pt-15 bookingHeaderSection" >
            <div className="section-shape section-shape1 top-inherit bottom-0" ></div>
            <div className="breadcrumb-outer">
                <div className="container">
                    <div className="breadcrumb-content text-center">
                        <h1 className="mb-3">Top Destinations</h1>
                    </div>
                </div>
            </div>
        </section>
        <section className="pb-15">
             <div className="container">
                <div className="row mb-2">
                
                    {sortedDestinations.map((destination, index) => ( 
                    <div className='col-lg-4 mb-1' key={index}>
                        
                        <Link to={`/flights/fly-${encodeURIComponent(destination.from)}-to-${destination.to.replace(/ /g, '-')}`}  >
                            <div className='destinationList' >
                                    <span className='cheapFlightText'>
                                        Cheap Flights
                                    </span>
                                    <span className='destinationText' >
                                        {destination.from} to {destination.to}
                                    </span>
                            </div>
                        </Link>
                    </div>
                    ))}
                </div>
            </div>
        </section>        

        </>
    )
}
export default TopDestination;